import { createBrowserClient } from '@supabase/ssr';

const url = import.meta.env.VITE_SUPABASE_PROJECT_URL as string;
const key = import.meta.env.VITE_SUPABASE_API_KEY as string;

if (!url || !key) {
  throw new Error(
    'Missing VITE_SUPABASE_PROJECT_URL / VITE_SUPABASE_API_KEY. Set them in the admin Netlify site env (or .env.local for vite dev).'
  );
}

export const supabase = createBrowserClient(url, key);
